"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotaNonNumeric = exports.notaNonNumeric = void 0;
exports.notaNonNumeric = ['D', 'N', '?', 'DT', 'DM'];
const isNotaNonNumeric = (string) => {
    return typeof string === 'string' && string in exports.notaNonNumeric;
};
exports.isNotaNonNumeric = isNotaNonNumeric;
// #endregion
